export const getLinkWithFallbackLinkStyles = () => ({
  fallbackIcon: {
    marginLeft: '1ex',
  },
});
